import { render, staticRenderFns } from "./ScaleBarChart.vue?vue&type=template&id=8e18a2ec&scoped=true&"
import script from "./ScaleBarChart.vue?vue&type=script&lang=js&"
export * from "./ScaleBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ScaleBarChart.vue?vue&type=style&index=0&id=8e18a2ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e18a2ec",
  null
  
)

export default component.exports